import React from "react";
import { PaymentSelector } from "./PaymentSelector";
import { MaybeCreditCardForm } from "../../CreditCard/MaybeCreditCardForm";
import { MaybeEmailForPaymentReceipt } from "../../Booking/OptionalParts/MaybeEmailForPaymentReceipt";
import { Separator } from "./Separator";

/**
 * Payment section for the booking. Appears only if the user opted to convert the booking to Fixed Price.
 */
export const PaymentSection: React.FC = () => {
    return (
        <div className="payment-section">
            <Separator />
            <div className="payment-method-title">Payment method <span className="payment-method-asterix">*</span></div>
            <div className="payment-method-description">Secure payment now. No charge until your trip ends.</div>
            <PaymentSelector />
            <MaybeCreditCardForm />
            <MaybeEmailForPaymentReceipt />
        </div>
    )
}